import React from "react";
import './MissingRoute.css';

export default function MissingRoute() {
  return (
    <div className="video">
      <h1>404 Page Not Fround</h1>
      <iframe
        width="470"
        height="835"
        src="https://www.youtube.com/embed/tjB2OF9bGAU?autoplay=1"
        title="Harry Potter Chess Scene Remix @zeo_choons  ⚡️ #harrypotter"
        frameborder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
        allowfullscreen
      ></iframe>
      ;
    </div>
  );
}
